import React from 'react';
import { observer } from 'mobx-react';
import { useClientStore } from 'apps/hooks';

import { Box, Button, IconButton } from 'components';
import { Delete /* Edit, Download, Share */ } from 'icons';

import type QuotePageAppManager from 'apps/shipmentQuote/QuotePage/appManager';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

const alignCenterStyle = {
  display: 'flex',
  alignItems: 'center',
};

interface ActionButtonsProps {
  quoteAppManager: QuotePageAppManager;
  loading: boolean;
  disabled: boolean;
}

export const HeaderActions = observer(function HeaderActions({
  quoteAppManager,
  loading,
  disabled = false,
}: ActionButtonsProps) {
  const clientStore = useClientStore();
  const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';

  const handleDeleteQuote = () => {
    modalStore.SetModalComponent(ConfirmAction, {
      callBack: () => {
        quoteAppManager.DeleteShipmentQuote();
      },
      title: 'Are you sure you want to delete this Shipment Quote?',
      undo: true,
    });
  };

  const handlePay = () => {
    quoteAppManager.PayQuote();
  };

  const areThereOrdersAttached = quoteAppManager.quote.orders.length > 0;

  if (isIntermediator) {
    return (
      <Box sx={alignCenterStyle}>
        {/* <IconButton variant='outlined' icon={<Edit />} mr={4} /> */}
        <IconButton
          variant='outlined'
          icon={<Delete />}
          onClick={handleDeleteQuote}
          disabled={areThereOrdersAttached}
        />
        {/* <Button
        text='Requote'
        size='small'
        icon='arrow_right'
        iconPosition='right'
        onClick={handleRequote}
      /> */}
      </Box>
    );
  }

  return (
    <Box sx={alignCenterStyle}>
      {/* <IconButton variant='outlined' icon={<Download />} mr={4} />
      <IconButton variant='outlined' icon={<Share />} mr={4} /> */}
      <Button
        text='Pay now'
        size='small'
        loading={loading}
        icon='arrow_right'
        iconPosition='right'
        onClick={handlePay}
        disabled={disabled}
      />
    </Box>
  );
});
